if (!customElements.get("variant-picker")) {
    class t extends HTMLElement {
        constructor() {
            super();

            this.section = this.closest(".js-product");
            this.productForm = this.section.querySelector(".js-product-form-main");
            this.optionSelectors = this.querySelectorAll(".option-selector");
            this.data = this.getProductData();

            // Set current active variant to null during setup
            this.variant = null;

            this.updateAddToCartButton();
            this.updateAvailability();

            this.addEventListener(
                "change",
                this.handleVariantChange.bind(this)
            );
        }

        handleVariantChange(e) {
            let selectedOptions = this.getSelectedOptions();

            const hasEmptySelection = selectedOptions.some(
                option => !option || option === ""
            );

            if (hasEmptySelection) {
                this.variant = null;
            } else {
                this.variant = this.data.product.variants.find(
                    variant =>
                        variant.options.every(
                            (value, index) =>
                                value === selectedOptions[index]
                        )
                );
            }

            if (this.variant) {
                this.updateMedia();
                this.updateUrl(e);
                this.updateVariantInput();
            }

            this.updateAddToCartButton();
            this.updateAvailability();
            this.updatePrice();
            this.updateBackorderText();
            this.updatePickupAvailability();
            this.updateSku();

            t.updateLabelText(e);

            this.dispatchEvent(
                new CustomEvent("on:variant:change", {
                    bubbles: true,
                    detail: {
                        form: this.productForm,
                        variant: this.variant,
                        product: this.data.product
                    }
                })
            );
        }

        updateAddToCartButton() {
            if (!this.productForm) {
                this.productForm =
                    this.section.querySelector(".js-product-form-main");
            }

            if (!this.productForm) return;

            this.addBtn =
                this.addBtn ||
                this.productForm.querySelector('[name="add"]');

            if (!this.addBtn) return;

            const addToCartText =
                this.addBtn.dataset.addToCartText || "Add to cart";

            const soldOutText =
                theme.strings.noStock || "No stock";

            // If a placeholder element is still targeted, lock down button interactions immediately
            let selectedOptions = this.getSelectedOptions();
            const hasEmptySelection = selectedOptions.some(
                option => !option || option === ""
            );

            if (!this.variant || hasEmptySelection) {
                this.addBtn.disabled = true;
                this.addBtn.textContent = addToCartText;
                return;
            }

            if (this.variant.available) {
                this.addBtn.disabled = false;
                this.addBtn.textContent = addToCartText;
            } else {
                this.addBtn.disabled = true;
                this.addBtn.textContent = soldOutText;
            }
        }

        updateAvailability() {
            if ("false" === this.dataset.showAvailability) return;

            let currentVariant = this.variant;

            if (!this.variant) {
                currentVariant = {
                    options: this.getSelectedOptions()
                };
            }

            const updateOption = (option, available, soldOut) => {
                // STRIP/SKIP: Completely clears modifications if the element contains placeholder properties
                if (option.dataset.placeholder === "true" || option.value === "" || option.dataset.value === "") {
                    let status = option.querySelector("em");
                    if (status) status.remove();
                    return;
                }

                let text =
                    soldOut
                        ? theme.strings.noStock
                        : theme.strings.noVariant;

                if (option.classList.contains("custom-select__option")) {
                    let status = option.querySelector("em");

                    if (status) {
                        status.hidden = available;
                    }

                    if (!available) {
                        if (status) {
                            status.textContent = text;
                        } else {
                            option.innerHTML +=
                                ` <em class="pointer-events-none">${text}</em>`;
                        }
                    }
                } else {
                    if (available) {
                        option.nextElementSibling.removeAttribute("title");
                    } else {
                        option.nextElementSibling.title = text;
                    }
                }
            };

            // Clear any active variations prior to processing combinations
            this.querySelectorAll(".js-option").forEach(option => {
                updateOption(option, true, false);
            });

            this.optionSelectors.forEach((selector, index) => {
                let currentSelVal = currentVariant.options[index];
                
                // If a sibling dropdown hasn't been configured, skip generation loops
                if (!currentSelVal || currentSelVal === "") {
                    return;
                }

                this.data.product.variants.forEach(variant => {
                    let matched = 0;

                    variant.options.forEach((value, optionIndex) => {
                        if (
                            value === currentVariant.options[optionIndex] &&
                            optionIndex !== index
                        ) {
                            matched++;
                        }
                    });

                    if (
                        matched ===
                        currentVariant.options.length - 1
                    ) {
                        let optionElement = Array.from(
                            selector.querySelectorAll(".js-option")
                        ).find(option =>
                            selector.dataset.selectorType === "dropdown"
                                ? option.dataset.value === variant.options[index]
                                : option.value === variant.options[index]
                        );

                        if (optionElement) {
                            updateOption(
                                optionElement,
                                variant.available,
                                !variant.available
                            );
                        }
                    }
                });
            });
        }

        updateBackorderText() {
            this.backorder =
                this.backorder ||
                this.section.querySelector(".backorder");

            if (!this.backorder) return;

            let hidden = true;

            if (this.variant && this.variant.available) {
                let inventory =
                    this.data.formatted[this.variant.id].inventory;

                if (
                    this.variant.inventory_management &&
                    inventory === "none"
                ) {
                    let title =
                        this.section.querySelector(".product-title");

                    let product =
                        this.backorder.querySelector(".backorder__product");

                    let variantTitle =
                        this.variant.title.includes("Default")
                            ? ""
                            : ` - ${this.variant.title}`;

                    product.textContent =
                        `${title.textContent}${variantTitle}`;

                    hidden = false;
                }
            }

            this.backorder.hidden = hidden;
        }

        static updateLabelText(e) {
            let selector =
                e.target.closest(".option-selector");

            if (
                !selector ||
                selector.dataset.selectorType === "dropdown"
            ) {
                return;
            }

            let text =
                selector.querySelector(".js-color-text");

            if (text) {
                text.textContent =
                    e.target.nextElementSibling
                        .querySelector(".js-value")
                        .textContent;
            }
        }

        updateMedia() {
            if (
                this.variant &&
                this.variant.featured_media
            ) {
                if (
                    this.section.matches("quick-add-drawer")
                ) {
                    this.section.updateMedia(
                        this.variant.featured_media.id
                    );
                } else {
                    this.mediaGallery =
                        this.mediaGallery ||
                        this.section.querySelector("media-gallery");

                    if (!this.mediaGallery) return;

                    let media =
                        this.mediaGallery.querySelector(
                            `[data-media-id="${this.variant.featured_media.id}"]`
                        );

                    if (media) {
                        this.mediaGallery.setActiveMedia(
                            media,
                            true,
                            true
                        );
                    }
                }
            }
        }

        updatePickupAvailability() {
            this.pickUpAvailability =
                this.pickUpAvailability ||
                this.section.querySelector("pickup-availability");

            if (!this.pickUpAvailability) return;

            if (
                this.variant &&
                this.variant.available
            ) {
                this.pickUpAvailability.getAvailability(
                    this.variant.id
                );
            } else {
                this.pickUpAvailability.removeAttribute(
                    "available"
                );

                this.pickUpAvailability.innerHTML = "";
            }
        }

        updatePrice() {
            this.price =
                this.price ||
                this.section.querySelector(
                    ".product-info__price > .price"
                );

            if (!this.price) return;

            // Check if ANY selector remains on the initial empty/placeholder option
            let selectedOptions = this.getSelectedOptions();
            const hasEmptySelection = selectedOptions.some(
                option => !option || option === ""
            );

            // If the user hasn't finished choosing options across ALL dropdowns, keep showing the default fallback price
            if (hasEmptySelection) {
                this.price.querySelector(".price__default").hidden = false;
                this.price.querySelector(".price__no-variant").hidden = true;
                return;
            }

            // Once ALL options are chosen, conditionally show price details or the "Unavailable" flag
            this.price.querySelector(".price__default").hidden =
                !this.variant;

            this.price.querySelector(".price__no-variant").hidden =
                !!this.variant;

            if (!this.variant) return;

            let current =
                this.price.querySelector(".price__current");

            let compare =
                this.price.querySelector(".price__was");

            let unit =
                this.price.querySelector(".unit-price");

            let formatted =
                this.data.formatted[this.variant.id];

            current.innerHTML = formatted.price;

            if (compare) {
                compare.innerHTML =
                    formatted.compareAtPrice || "";
            }

            if (this.variant.unit_price_measurement) {
                let unitPrice =
                    this.price.querySelector(
                        ".unit-price__price"
                    );

                let unitLabel =
                    this.price.querySelector(
                        ".unit-price__unit"
                    );

                let refValue =
                    this.variant.unit_price_measurement.reference_value;

                let refUnit = 'piece';

                unitPrice.innerHTML =
                    formatted.unitPrice;

                unitLabel.textContent =
                    refValue === 1
                        ? refUnit
                        : `${refValue} ${refUnit}`;
            }

            unit.hidden =
                !this.variant.unit_price_measurement;

            this.price.classList.toggle(
                "price--on-sale",
                this.variant.compare_at_price >
                    this.variant.price
            );

            this.price.classList.toggle(
                "price--sold-out",
                !this.variant.available
            );
        }

        updateSku() {
            this.sku =
                this.sku ||
                this.section.querySelector(
                    ".product-sku__value"
                );

            if (!this.sku) return;

            let sku =
                this.variant?.sku || "";

            this.sku.textContent = sku;
            this.sku.parentNode.hidden = !sku;
        }

        updateUrl(e) {
            if (
                e &&
                e.type === "change" &&
                this.dataset.updateUrl !== "false" &&
                this.variant
            ) {
                window.history.replaceState(
                    {},
                    "",
                    `${this.dataset.url}?variant=${this.variant.id}`
                );
            }
        }

        updateVariantInput() {
            this.forms =
                this.forms ||
                this.section.querySelectorAll(
                    ".js-product-form-main, .js-instalments-form"
                );

            this.forms.forEach(form => {
                let input =
                    form.querySelector('input[name="id"]');

                input.value = this.variant.id;

                input.dispatchEvent(
                    new Event("change", {
                        bubbles: true
                    })
                );
            });
        }

        getSelectedOptions() {
            let options = [];

            this.optionSelectors.forEach(selector => {
                if (
                    selector.dataset.selectorType ===
                    "dropdown"
                ) {
                    let customSelect =
                        selector.querySelector(
                            "custom-select"
                        );

                    if (customSelect) {
                        let selected =
                            customSelect.querySelector(
                                '[aria-selected="true"]'
                            );

                        options.push(
                            selected?.dataset.value || ""
                        );
                    }
                } else {
                    let checked =
                        selector.querySelector(
                            "input:checked"
                        );

                    options.push(
                        checked?.value || ""
                    );
                }
            });

            return options;
        }

        getDefaultOptionText() {
            return "";
        }

        getProductData() {
            return JSON.parse(
                this.querySelector(
                    '[type="application/json"]'
                ).textContent
            );
        }
    }

    customElements.define("variant-picker", t);
}